<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { ContactData, ContactFormData } from '@/models/contact';
  import ContactInfo from '@/components/contact/ContactInfo.vue';
  import ContactForm from '@/components/contact/ContactForm.vue';

  defineProps({
    contactData: {
      type: Object as PropType<ContactData>,
      required: true
    },
    packageNames: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    selectedPackage: {
      type: String,
      required: false,
      default: undefined
    },
    localePath: {
      type: Function as PropType<(to: any) => string>,
      required: true
    }
  });

  const emit = defineEmits(['onSubmit']);

  const onSubmit = (data: ContactFormData) => {
    emit('onSubmit', data);
  };
</script>

<template>
  <section
    id="contact-section"
    class="contact-section">
    <div class="container">
      <div class="contact-section__wrapper">
        <ContactInfo :contact-data="contactData" />
        <ContactForm
          :locale-path="localePath"
          :selected-package="selectedPackage"
          :package-names="packageNames"
          @on-submit="onSubmit" />
      </div>
    </div>
  </section>
</template>
